import el from "@cypherpotato/el";
import page from "page";
import { Button, PrimaryButton } from "../../components/button";
import { CenteredCard, CenteredCardContent, CenteredCardHeader } from "../../components/centered-card";
import { TextInput } from "../../components/form";
import { LoginKeyInput } from "../../components/login-key-input";
import { Main, Row, Section } from "../../components/layout";
import { SpecializedControl } from "../../components/specializedObject";
import { MutedText } from "../../components/text";
import { isAuthed, putSession } from "../../session";
import { displayFormControl } from "../../ui/alert";
import { runOperation } from "../../ui/operation";
import { api } from './../../api';
import { Icon } from './../../components/icon';

export default function (ctx) {

    let loginKeyValue = "";
    var loginKeyInput;

    async function handleSubmit(key) {
        const loginKey = key || loginKeyValue;
        if (loginKey.length !== 14) return;

        await runOperation("Logging in...", async () => {
            try {
                const result = await api.postJson("/api/v1/auth/login", {
                    loginKey
                });

                putSession({
                    sessionKey: result.data.accessToken,
                    data: result.data.account
                });

                page(window.redirectAfterLogin || "/dashboard");
            } catch {
                loginKeyInput.setValue("");
            }
        });
    }

    if (isAuthed()) {
        page(window.redirectAfterLogin || "/dashboard");
        return;
    }

    return Main(
        CenteredCard(
            CenteredCardHeader("Login", "Enter your Compound login key below."),
            CenteredCardContent(
                Section(
                    LoginKeyInput({
                        onChange(value) {
                            loginKeyValue = value;
                        },
                        onComplete(value) {
                            handleSubmit(value);
                        },
                        onCreate(input) {
                            loginKeyInput = input;
                        }
                    })
                ),
                Section(
                    el("div.login-key-hint",
                        Icon("keyboard-line"),
                        MutedText("Paste or type your 14-digit login key to log in automatically")
                    )
                ),
                Section(
                    el("div.login-key-register",
                        "Don't have an account? ",
                        el("a[href='#']", "Register", {
                            onClick() {
                                displayFormControl({
                                    title: "Register",
                                    message: "",
                                    formControlItem: SpecializedControl({
                                        fields: [
                                            {
                                                name: "name",
                                                label: "Full name",
                                                control: TextInput("fullName", "Enter your full name")
                                            },
                                            {
                                                name: "email",
                                                label: "E-mail",
                                                control: TextInput("email", "E-mail address", { type: "email" })
                                            }
                                        ]
                                    }),
                                    validate: [
                                        [x => x.name.length >= 3, "Please enter your full name."],
                                        [x => /\S+@\S+\.\S+/.test(x.email), "Please enter a valid e-mail address."]
                                    ],
                                    onConfirm(data) {
                                        grecaptcha.ready(function () {
                                            grecaptcha.execute(window.captchaSiteKey, { action: 'submit' }).then(function (token) {
                                                runOperation("Creating your account...", async () => {
                                                    await api.postJson("/api/v1/auth/register", {
                                                        userName: data.name,
                                                        email: data.email,
                                                        captchaToken: token
                                                    });
                                                });
                                            });
                                        });
                                    }
                                })
                            }
                        })
                    )
                )
            )
        )
    );
}
